import React, { useState } from "react"
import {
    Box,
    componentStyles,
    TextLargeBold,
} from "@mallardbay/lib-react-components"

import COPY from "~config/copy-constants"
import SimpleGrid from "~components/shared/todo-lib-react-components/simple-grid"
import ResourceItemModal from "~components/pages/outfitter/resources/resource-item-modal"
import type { ResourceFieldsFragment } from "~graphql/generated/graphql"

import IncludedResource from "../included-resource"

import { useCheckoutFlow } from "./checkout-flow-provider"

export default function CheckoutFlowResources() {
    const styles = useStyles()
    const [selectedResource, setSelectedResource] =
        useState<ResourceFieldsFragment | null>(null)

    const { pricingPackage } = useCheckoutFlow()

    const resources = pricingPackage?.included_resource_ids ?? []

    return (
        <Box>
            <TextLargeBold style={styles.title}>
                {COPY.RESOURCES.CHECKOUT_INCLUDED}
            </TextLargeBold>
            <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }}>
                {resources.map((resourceId) => {
                    return (
                        <IncludedResource
                            resourceId={resourceId}
                            key={resourceId}
                            onClick={setSelectedResource}
                        />
                    )
                })}
            </SimpleGrid>
            {selectedResource && (
                <ResourceItemModal
                    resource={selectedResource}
                    onClose={() => {
                        setSelectedResource(null)
                    }}
                />
            )}
        </Box>
    )
}

function useStyles() {
    return componentStyles({
        title: {
            marginBottom: 4,
        },
    })
}
